/**
 * Authentication Configuration
 * 
 * Controls authentication features and access
 */

export const AUTH_CONFIG = {
  // Set to false to disable new user sign ups
  // Existing users can still sign in
  allowSignUp: true,
  
  // Set to true to show a message when sign up is disabled
  showSignUpDisabledMessage: true,
  
  // Message to show when sign up is disabled
  signUpDisabledMessage: 'Sign up is currently disabled. Contact the developer for access.',
} as const;
